import { getVisibleArrows } from '../../../core/components/axes/components/PanningControls/get-visible-arrows.js';
import { PanningControls } from '../../../core/components/axes/components/PanningControls/PanningControls.js';
import { useCurrentDomainState } from '../../hooks/store/selectors.js';
import { useHistogramXScale } from '../../hooks/useHistogramXScale.js';
import { useHistogramZoomRanges } from '../../hooks/useHistogramZoomRanges.js';
import { useInfiniteZoomConfig } from '../../hooks/useInfiniteZoomConfig.js';

interface HistogramPanningControlsProps {
  onClickPan: (domain: number) => void;
}

export const HistogramPanningControls = (
  props: HistogramPanningControlsProps,
) => {
  const { onClickPan } = props;

  const currentDomain = useCurrentDomainState();
  const infiniteZoom = useInfiniteZoomConfig();
  const { initialZoom } = useHistogramZoomRanges();
  const { minMaxBoundaries } = useHistogramXScale();

  const { left, right } = getVisibleArrows(
    minMaxBoundaries,
    initialZoom,
    currentDomain,
    infiniteZoom,
  );

  return (
    <PanningControls
      onClickPan={onClickPan}
      showLeftControl={left}
      showRightControl={right}
    />
  );
};
